export const ACCOUNT = {
  SIGN_IN: "signIn",
  FIND_ID: "findId",
  FIND_PWD: "findPwd",
  SUCCESS_FIND: "successFind",
  SIGN_UP: "signUp",
  SNS_LOGIN: "snsLogin",
  CONNECT_ANOTHER_ACCOUNT: "connectAnotherAccount",
  ACCOUNT_CONNECT: "accountConnect",
  ACCOUNT_CONNECT_COMPLETED: "accountConnectCompleted",
  NEEDS_TO_SIGN_UP: "needsToSignUp",
  TERMS_SIGN: "termsSign",
  SET_NICKNAME: "setNickname",
};
